import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';
import PageSizeSelector from '../../components/PageSizeSelector';

const Pagination = ({ PAGE_SIZE, page, total, pages, setPage, setPageSize }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '16px 32px',
        borderTop: `1px solid ${S.borderLight}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <div style={{ fontSize: 13, color: S.textMuted }}>
        {t('screens.riskSignals.showingCount', {
          from: Math.min((page - 1) * PAGE_SIZE + 1, total),
          to: Math.min(page * PAGE_SIZE, total),
          total,
        })}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {typeof PAGE_SIZE === 'number' && setPageSize && (
          <PageSizeSelector pageSize={PAGE_SIZE} setPageSize={setPageSize} />
        )}
        <div style={{ display: 'flex', gap: 6 }}>
        <button
          onClick={() => setPage(p => Math.max(1, p - 1))}
          disabled={page === 1}
          style={{
            padding: '7px 14px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 500,
            color: S.textSecondary,
            cursor: page === 1 ? 'default' : 'pointer',
            opacity: page === 1 ? 0.4 : 1,
          }}
        >
          {t('screens.riskSignals.previous')}
        </button>
        {Array.from({ length: Math.min(pages, 7) }, (_, i) => i + 1).map(p => (
          <button
            key={p}
            onClick={() => setPage(p)}
            style={{
              padding: '7px 12px',
              background: p === page ? S.burgundy : '#fff',
              color: p === page ? '#fff' : S.textSecondary,
              border: `1px solid ${p === page ? S.burgundy : S.borderLight}`,
              borderRadius: 8,
              fontSize: 13,
              fontWeight: p === page ? 700 : 500,
              cursor: 'pointer',
            }}
          >
            {p}
          </button>
        ))}
        <button
          onClick={() => setPage(p => Math.min(pages, p + 1))}
          disabled={page === pages}
          style={{
            padding: '7px 14px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 500,
            color: S.textSecondary,
            cursor: page === pages ? 'default' : 'pointer',
            opacity: page === pages ? 0.4 : 1,
          }}
        >
          {t('screens.riskSignals.next')}
        </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
